module.exports = __webpack_public_path__ + "static/media/bkg-wall-e-02.f41d70f6.jpg";